import { Component, OnInit } from "@angular/core";
import { councilSlideInAnimation } from "./council-route-animation";

@Component({
  selector: "app-main-council",
  templateUrl: "./main-council.component.html",
  styleUrls: ["./main-council.component.scss"],
  animations: [councilSlideInAnimation]
})
export class MainCouncilComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
